<template>
    <div v-loading="loading" class="alarmClass">
      <div>
        <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      
      ref="crud"
      @on-load="onLoad"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="onLoad"
      @selection-change="selectionChange"
    >
    <template slot="menuLeft">
        <el-button
          
          type="primary"
          icon="el-icon-plus"
          size="small"
          @click="addRecord"
        >
          新 增</el-button
        >
      </template>
    </avue-crud>
      </div>
      <hr-dialog title="新增维修记录" :allowFull="false" width="60%" :visible.sync="repairFormVisible">
      <template slot="body">
        <repairForm
        
          :row="row"
          @cancle="recordCancle"
          v-if="repairFormVisible"
          @success="recordSuccess"
         
        ></repairForm>
      </template>
    </hr-dialog>
    </div>
  </template>
    <script>

  import repairForm from './repairForm.vue';
  import { getSmartDeviceResumeRepairlist } from '@/api/nursingHome/elderDevice';
  export default {
    components: {repairForm},
    props: {
      row: {
        default: {},
      },
      nursinghomeId: {},
      model: {
        default: 'add',
      },
    },
    data() {
      return {
        repairFormVisible:false,
        formRow:{},
       data:[],
       option: {
        selection: false,
        select: true,
        index: true,
        indexLabel: '#',
        page: true,
        height: '500',
        calcHeight: 'auto',
        align: 'left',
        menu: false,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        border: true,
        column: [
          {
            label: '报修日期',
            prop: 'reportTime',
          },
          {
            label: '维修人员',
            prop: 'repairUserName',
          },
          {
            label: '故障类型',
            prop: 'troubleType',
          },
          {
            label: '故障原因',
            prop: 'troubleReason',
          },
          {
            label: '维修开始时间',
            prop: 'repairStartTime',
          },
          {
            label: '维修结束时间',
            prop: 'repairEndTime',
          },
          {
            label: '维修费用',
            prop: 'repairAmount',
          },
          {
            label: '维修说明',
            prop: 'description',
          },
         
        ],
      },
      // page: {
      //   pageSize: 10,
      //   currentPage: 1,
      //   total: 0,
      // },
      loading: false,
      };
    },
    created() {
      this.initData();
    },
    mounted() {},
    watch: {},
    methods: {
      refleshTable(){
        setTimeout(() => {
        this.$nextTick(() => {
        this.$refs.crud.doLayout();
      })
      },100)
      },
      addRecord(row){
        this.repairFormVisible =true
      }
    ,
       initData() {
        
       
      },
      recordCancle(){
        this.repairFormVisible =false
      },
      recordSuccess(){
        this.repairFormVisible =false
        this.onLoad()
      },
      onLoad(){
        getSmartDeviceResumeRepairlist({id: this.row.id}).then((res) => {
          this.data = res.data
        })
      }
    },
  };
  </script>
    <style scoped>
  .alarmClass {
    height: 100%;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
  }
  ::v-deep .el-col-8 {
    height: 54px;
  }
  </style>
    